import { callApi, ENDPOINTS } from 'utils/api/callApi'
import {
  ICheckTokenStatusResponse,
  ITokenStatus,
  IResetTokenResponse,
} from 'apps/fleet-planner/types'

/**
 * Checks the status of an invitation token.
 * @method GET
 * @param token - the token to validate.
 */
export const getTokenStatus = async (token: string): Promise<ITokenStatus> => {
  try {
    const { status }: ICheckTokenStatusResponse = await callApi({
      endpoint: ENDPOINTS.token,
      id: token,
      method: 'GET',
    })
    return status
  } catch {
    return 'invalid'
  }
}

/**
 * Resends an invitation token by email to the original recipient of a given invitation token.
 * @method PUT
 * @param token - the token to be reset.
 */
export const resetToken = async (token: string): Promise<string> => {
  const { email }: IResetTokenResponse = await callApi({
    endpoint: ENDPOINTS.token,
    id: token,
    method: 'PUT',
  })
  return email
}
